export const SHOW_DIALOG = "dialog/SHOW_DIALOG";
export const HIDE_DIALOG = "dialog/HIDE_DIALOG";


export const ShowDialog = (header, body, icon, labelOk, labelCancel, severity, okFn, cancelFn)=>{
    return {type: SHOW_DIALOG, header, body, icon, labelOk, labelCancel, severity, okFn, cancelFn}
}

export const HideDialog = ()=>{    
    return {type: HIDE_DIALOG}
}